import actions from './actions';
import initialState from '../initialState';

export const userReducer = (state = initialState.user, action) => {
    switch (action.type) {
        case actions.USER_UPDATE:
            return { ...state, ...action.user };
        case actions.USER_LOG_OUT:
            return { ...initialState };
        case actions.BFIAPPLY_USER_ADD:
            return { ...state, bfiUserAddModal: action.state.bfiUserAddModal };
        default:
            return state;
    }
};

export default userReducer;
